import apiRoutes from "startups/apiRoutes";
import { createActionFetcher } from "shared/redux-store/defaults";
import { getData, catchHttpError } from "shared/api";

export const fetchDigitalizedOrdersOverview = createActionFetcher(
  "DIGITALIZED_ORDERS",
  [apiRoutes.externalOrdersPath()],
);

export const fetchDigitalizedOrdersOverviewAll = createActionFetcher(
  "DIGITALIZED_ORDERS",
  [apiRoutes.externalOrdersAllPath()],
);

export function fetchDigitalizedOrdersDetail(id) {
  return dispatch =>
    dispatch({
      type: "FETCH_DIGITALIZED_ORDERS_DETAIL",
      payload: Promise.all([getData(apiRoutes.externalOrderPath(id))]),
    }).catch(catchHttpError);
}
